<div class="d-flex align-items-end flex-wrap">
  <div class="d-flex align-items-end flex-grow-1">
    <div class="form-group m-0 type-ahead-field">
      <label>{{ label }}</label>
      <input type="text"
        [ngbTypeahead]="search"
        [inputFormatter]="formatter"
        [ngModel]="selectedItem"
        [resultFormatter]="resultFormatter"
        (selectItem)="selectItem($event)"
        class="form-control"
        placeholder="Reporting Location"
        [required]="required"
        [disabled]="selectedItem !== undefined"
        [resultTemplate]="rt">
      @if (selectedItem) {
        <button class="clear-search"
          type="button"
          (click)="clear()">
          <i class="fas fa-times-circle"></i>
        </button>
      }
    </div>
    <button type="button"
      class="btn btn-action ml-2 search-button py-0"
      (click)="openTreeView()">
      <reporter-icon [icon]="selectedItem ? 'ViewFacility' : 'Search'"></reporter-icon>
    </button>
  </div>
  @if (showSubUnitsChecked) {
    <div
      class="custom-checkbox">
      <input type="checkbox"
        class="custom-control-input"
        [(ngModel)]="subUnitsChecked"
        (change)="emitLocalData()"
        id="includeSubUnits"/>
      <label class="custom-control-label"
      for="includeSubUnits">Include Sub-Units</label>
    </div>
  }
</div>

<ng-template #rt let-r="result" let-t="term">
  <div class="d-flex flex-column">
    <div>
      <ngb-highlight [result]="r.displayName"
        highlightClass="highlight"
      [term]="t"></ngb-highlight>
    </div>
    <div class="text-muted small">
      @if (r.location_code) {
        <span class="mr-1">
          <b>Location Code:</b>&nbsp;
          <ngb-highlight [result]="r.location_code"
            [term]="t"
          highlightClass="highlight"></ngb-highlight>
        </span>
      }
      @if (r.address) {
        <span class="mr-1">
          <b>Address:</b>&nbsp;
          <ngb-highlight [result]="r.address"
            [term]="t"
          highlightClass="highlight"></ngb-highlight>
        </span>
      }
      @if (r.phone) {
        <span>
          <b>Phone:</b>&nbsp;
          <ngb-highlight [result]="r.phone"
            [term]="t"
          highlightClass="highlight"></ngb-highlight>
        </span>
      }
    </div>
  </div>
</ng-template>
